import { Component, OnInit, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { ProfileService } from '../shared/profile.service';
import { Contact } from '../../contacts/shared/contact.model';
import { ProfileContactEditComponent } from './profile-contact-edit/profile-contact-edit.component';
import { NotificationService, PagedResultGeneric, TranslationService } from '../../shared';
import { ConfirmationService } from 'primeng/api';
import { Title } from '@angular/platform-browser';
import { UserService } from 'src/app/users/shared/user.service';
import { SecurityAccessLevelEnum } from 'src/app/shared/auth/enum/security-access-level.enum';

@Component({
  selector: 'wl-profile-contacts',
  templateUrl: './profile-contacts.component.html',
  styleUrls: ['./profile-contacts.component.less'],
    standalone: false
})
export class ProfileContactsComponent implements OnInit {
  public profileId = 0;
  public contacts: PagedResultGeneric<Contact> = { Result: [] } as PagedResultGeneric<Contact>;
  public startDate = new Date();
  public endDate = new Date();
  public editableContact: Contact = {} as Contact;
  profileContactsTabFullAccess: boolean = false;

  @ViewChild(ProfileContactEditComponent) contactEdit: ProfileContactEditComponent;

  private _routeSubscription: Subscription;
  constructor(
    private _profileService: ProfileService,
    private _route: ActivatedRoute,
    private _notificationService: NotificationService,
    private _confirmationService: ConfirmationService,
    private _translationService: TranslationService,
    private _title: Title,
    private _userService: UserService
  ) {
    this.endDate = new Date();
    this.startDate = new Date();
    this.startDate.setDate(this.startDate.getDate() - 365);
  }

  ngOnInit() {
    this._routeSubscription = this._route.params.subscribe((params) => {
      this.profileId = parseInt(params.id, 10);
      this.loadContacts(1);

      this._profileService.getProfile(this.profileId).then((data) => {
        this._title.setTitle(data.ReportName + ' ' + this._translationService.getInstant('common.profile.contacts'));
      });
    });

    this._userService.getCurrentUserSecurityElementAccessLevel('ProfileContacts_Tab').then((userAccessLevel: number) => {
      this.profileContactsTabFullAccess = userAccessLevel > SecurityAccessLevelEnum.ReadOnlyAccess;;
    });
  }
  public onPagingEvent(page: number) {
    this.loadContacts(page);
  }

  loadContacts(page: number, forceRefresh?: boolean) {
    this._profileService.getProfileContacts(this.profileId, this.startDate, this.endDate, page, forceRefresh).then((data) => {
      this.contacts = data;
    });
  }

  onEditClicked(contact: Contact) {
    this.editableContact = contact;
    this.contactEdit.profileContact = contact;
    this.contactEdit.open();
  }

  onDeleteClicked(contact: Contact) {
    this._confirmationService.confirm({
      message: this._translationService.getInstant('profiles.contact.delete-message'),
      key: 'deleteContactCD',
      accept: () => {
        this._profileService
          .DeleteProfileContact(contact)
          .then(() => {
            const contactIndex = this.contacts.Result.findIndex((x) => x == contact);
            this.contacts.Result.splice(contactIndex, 1);
          })
          .catch((error) => {
            this._notificationService.httpError(error);
          });
      },
      reject: () => {
        this._confirmationService.close();
      },
    });
  }

  onEditSubmitClicked(contact: Contact) {
    let promise = Promise.resolve();
    if (contact.ContactId) {
      promise = this._profileService.UpdateProfileContact(contact);
    } else {
      promise = this._profileService.CreateProfileContact(contact);
    }
    promise.then(
      () => {
        this.loadContacts(1, true);
        this.contactEdit.close();
      },
      (error) => {
        this._notificationService.httpError(error);
      }
    );
  }

  addContactClick() {
    this.editableContact = { ProfileId: this.profileId, ContactDate: new Date() } as Contact;
    this.contactEdit.profileContact = this.editableContact;
    this.contactEdit.open();
  }

  selectedDateChange() {
    this.loadContacts(1);
  }
}
